import { Grid } from "@material-ui/core";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";

import Produkt from "./Produkt";
import BtnAuswahl from './BtnAuswahl';

const ProduktDevDesktop: React.FC<{ loading: boolean }> = ({ loading }) => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const produktMitSchutzbrief = wizardFormBo.angebot.produktMitSchutzbrief;

    const handleOnClick = (mitSchutzbrief: boolean) => {
        wizardFormBo.angebot.produktMitSchutzbrief = mitSchutzbrief;
        fireWizardFormBo(wizardFormBo);
    }

    return (
        <Grid container spacing={5}>
            <Grid item xs={6} md={6}>
                {/* Produkt OHNE Schutzbrief */}
                <Produkt loading={loading} mobileVersion={false} mitSchutzbrief={false} active={!produktMitSchutzbrief}
                    btn={<BtnAuswahl disabled={loading} selected={!produktMitSchutzbrief} onClick={() => handleOnClick(false)} />} infoOnly={false} />
            </Grid>

            <Grid item xs={6} md={6}>
                {/* Produkt MIT Schutzbrief */}
                <Produkt loading={loading} mobileVersion={false} mitSchutzbrief={true} active={produktMitSchutzbrief}
                    btn={<BtnAuswahl disabled={loading} selected={produktMitSchutzbrief} onClick={() => handleOnClick(true)} />} infoOnly={false} />
            </Grid>
        </Grid>);
}

export default ProduktDevDesktop;